import script from "./MultiShipDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiShipDetails.vue?vue&type=script&setup=true&lang=js"

import "./MultiShipDetails.vue?vue&type=style&index=0&id=d1fa5d22&lang=scss"

const __exports__ = script;

export default __exports__